/* Announcement Bar Countdown — lightweight, no app */
(() => {
  const cfg = {
    // MODE: 'daily' = resets every day at the cutoff time below
    // MODE: 'fixed' = counts down to a specific date/time
    mode: 'daily',
    cutoffHour: 23,      // daily cutoff hour (24h)
    cutoffMinute: 59,    // daily cutoff minute
    fixedDeadline: '2025-12-31T23:59:59', // used only if mode === 'fixed'
  };

  const SELECTORS = ['.utility-bar', '.announcement-bar', '[data-section-type="announcement-bar"]'];

  const pad = n => String(n).padStart(2, '0');

  function getNextCutoffLocal() {
    const now = new Date();
    const t = new Date(now);
    t.setHours(cfg.cutoffHour, cfg.cutoffMinute, 0, 0);
    if (t <= now) t.setDate(t.getDate() + 1);
    return t;
  }

  function getTarget() {
    return cfg.mode === 'fixed' ? new Date(cfg.fixedDeadline) : getNextCutoffLocal();
  }

  function mountPlaceholders(root) {
    const candidates = root.querySelectorAll('a, p, span, div');
    candidates.forEach(el => {
      if (el.childElementCount === 0 && el.textContent.includes('{timer}')) {
        el.innerHTML = el.textContent.replace('{timer}', '<span class="annc-timer" aria-live="polite">--:--:--</span>');
      }
    });
  }

  function start() {
    const containers = SELECTORS
      .map(s => Array.from(document.querySelectorAll(s)))
      .flat()
      .filter(Boolean);

    if (!containers.length) return;

    containers.forEach(mountPlaceholders);

    let target = getTarget();

    function tick() {
      const now = new Date();
      if (now >= target) target = getTarget();
      const diff = Math.max(0, target - now);
      const h = pad(Math.floor(diff / 36e5));
      const m = pad(Math.floor((diff % 36e5) / 6e4));
      const s = pad(Math.floor((diff % 6e4) / 1000));
      document.querySelectorAll('.annc-timer').forEach(el => (el.textContent = `${h}:${m}:${s}`));
    }

    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', start);
})();
